import React, { useState } from 'react';
import './Select.css';

const Select = ({ 
  options = [],
  value = '',
  onChange,
  onBlur,
  onFocus,
  disabled = false,
  error = false,
  success = false,
  label = '',
  helperText = '',
  errorText = '',
  size = 'medium',
  placeholder = 'Select an option',
  className = '',
  ...props 
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const baseClasses = 'select';
  const sizeClasses = `select-${size}`;
  const stateClasses = error ? 'select-error' : success ? 'select-success' : '';
  const focusClasses = isFocused ? 'select-focused' : '';
  const disabledClasses = disabled ? 'select-disabled' : '';
  
  const classes = [baseClasses, sizeClasses, stateClasses, focusClasses, disabledClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="select-wrapper">
      {label && (
        <label className="select-label">
          {label}
        </label>
      )}
      <select
        className={classes}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {(helperText || errorText) && (
        <div className={`select-helper ${error ? 'select-helper-error' : ''}`}>
          {error ? errorText : helperText}
        </div>
      )}
    </div>
  );
};

export default Select;
